namespace app.toolbar {

    'use strict';
    
    export class ToolbarService {

        private configurations: any[] = [];

        public pushConfiguration(configuration: any) {
            this.configurations.push(configuration);
        }

        public clearConfigurations() {
            while(this.configurations.length > 0) {
                this.configurations.pop();
            }
        }

        public getConfigurations(): any[] {
            return this.configurations.sort((a, b) => {
                if (a.order < b.order)
                    return 1;
                if (a.order > b.order)
                    return -1;
                return 0;
            });
        }
    
    }

    angular.module("app.toolbar").service("toolbarService", ToolbarService);

}